const urlB64ToUint8Array = base64String => {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
        .replace(/-/g, '+')
        .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
};

export const getPushSubscriptionEndpoint = async () => {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return null;
    try {
        const registration = await navigator.serviceWorker.ready;
        const subscription = await registration.pushManager.getSubscription();
        return subscription ? subscription.endpoint : null;
    } catch (e) {
        return null;
    }
};

export const subscribeToPush = async (userEmail) => {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
        console.warn('[PushService] Push messaging is not supported in this browser/context (HTTP?).');
        return;
    }

    try {
        console.log('[PushService] Waiting for service worker to be ready...');
        const registration = await navigator.serviceWorker.ready;
        console.log('[PushService] Service worker ready:', registration.scope);

        if (Notification.permission !== 'granted') {
            console.warn('[PushService] Notification permission is not granted, skipping subscription.');
            return;
        }

        let subscription = await registration.pushManager.getSubscription();
        
        if (!subscription) {
            const publicKey = process.env.REACT_APP_VAPID_PUBLIC_KEY;
            if (!publicKey) {
                console.error('[PushService] Missing REACT_APP_VAPID_PUBLIC_KEY in environment');
                return;
            }
            console.log('[PushService] Creating new push subscription...');
            const applicationServerKey = urlB64ToUint8Array(publicKey);
            subscription = await registration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey
            });
            console.log('[PushService] Push subscription created:', subscription.endpoint);
        } else {
            console.log('[PushService] Reusing existing push subscription:', subscription.endpoint);
        }

        const p256dh = btoa(String.fromCharCode.apply(null, new Uint8Array(subscription.getKey('p256dh'))));
        const auth = btoa(String.fromCharCode.apply(null, new Uint8Array(subscription.getKey('auth'))));

        const apiUrl = (process.env.REACT_APP_U2_ACCOUNTSVC_API || 'http://subscribe.dev.orthup.com/api/') + 'push/subscribe';
        console.log('[PushService] Sending subscription to backend:', apiUrl);

        const response = await fetch(apiUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify({
                email: userEmail,
                endpoint: subscription.endpoint,
                keysP256dh: p256dh,
                keysAuth: auth
            })
        });

        if (!response.ok) {
            const body = await response.text().catch(() => '');
            console.error('[PushService] Backend returned error:', response.status, body);
        } else {
            console.log('[PushService] Successfully subscribed to push notifications for', userEmail);
        }
    } catch (err) {
        console.error('[PushService] Error during push subscription:', err);
    }
};

export const unsubscribeFromPush = async () => {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;
    try {
        const registration = await navigator.serviceWorker.ready;
        const subscription = await registration.pushManager.getSubscription();
        if (subscription) {
            await subscription.unsubscribe();
            console.log('[PushService] Successfully unsubscribed from push notifications locally.');
            
            const apiUrl = (process.env.REACT_APP_U2_ACCOUNTSVC_API || 'http://subscribe.dev.orthup.com/api/') + 'push/unsubscribe';
            await fetch(apiUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ endpoint: subscription.endpoint })
            }).catch(e => console.error('[PushService] Failed to notify backend of unsubscription:', e));
        }
    } catch (err) {
        console.error('[PushService] Error during push unsubscription:', err);
    }
};
